import React from 'react';
import playImg from '../../../images/play.svg';
import { Image } from '../../../../shared/src/components/Image';
import { InGameService } from '../../services/InGameService';
import { useDispatch, useSelector } from 'react-redux';
import { useAsgActions } from '../../../../shared/src/hooks/use-asg-actions.hook';

export const GameItem = ({ onOpenGame, data, playBtnText = false }) => {
    const dispatch = useDispatch();
    const { closeAndLoadGame, showRegistration } = useAsgActions();
    const { isLoggedIn } = useSelector((state) => state.player);
    const { gamesById } = useSelector((state) => state.casino);

    /**
     * open game by game id and game mode
     * @param gameData
     */
    const openGame = (gameData) => {
        InGameService.openGame({
            gameId: gameData.id,
            gamesById,
            isLoggedIn,
            dispatch,
            closeAndLoadGame,
            showRegistration,
        });
    };

    return <div key={data.id} className="result__item">
        <Image
            onClickHandler={() => {
                openGame(data);
                onOpenGame(data);
            }}
            className="result__image"
            images={data.images}
        />
        <div className="result__text-wrapper">
            <div  className="result__name">
                {data.name}
            </div>
            <div className="result__provider-name">
                {data.externalGameSubProvider || data.externalGameProvider}
            </div>
        </div>
        <div className="result__play-button-wrapper">
            <div onClick={() => {
                openGame(data);
                onOpenGame(data);
            }}
            className="result__play-button">
                {playBtnText ? playBtnText.toLowerCase() : <img src={playImg} alt=""/>}
            </div>
        </div>
    </div>;
};
